module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedExtraLight.33094bd.ttf";